import React from "react";
import { useRef } from "react";
import moment from "moment";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FiDownload } from "react-icons/fi";
import { numberToWords } from "../../util/numberToWords";
import logo from "../../assets/images/logo.png";

const Invoice = ({ invoiceData }) => {
  const invoiceRef = useRef(null);
  const {
    data,
    payment_status,
    application_data,
    webaddress,
    webphone,
    webemail,
    webgst,
  } = invoiceData;

  const memberDetails = data[0];
  const paymentDetails = payment_status[0];
  const applicationDetails = application_data[0];

  const invoiceNumber = `INV-${memberDetails.application_no}`;
  const memberNumber = memberDetails.membership_no ? `${memberDetails.membership_no}`: "N/A";
  const issueDate = moment().format("DD - MMM - YYYY");
  const dueDate = moment().add(2, "years").format("DD - MMM - YYYY");

  // Convert total price to words
  const amountInWords = numberToWords(applicationDetails.totalPrice);

  const handleDownloadPDF = () => {
    if (!invoiceRef.current) return;

    // Use html2canvas to capture the invoice as an image
    html2canvas(invoiceRef.current, {
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      // Create PDF with proper dimensions (A4)
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 0;

      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save(
        `${memberDetails.first_name}-${memberDetails.application_no}.pdf`
      );
    });
  };

  return (
    <div className="flex flex-col items-center">
      <div className="w-full relative mb-16 download_button_div">
        <button
          onClick={handleDownloadPDF}
          className="btn btn-primary"
        >
          <FiDownload size={18} /> Download PDF
        </button>
      </div>
      <div
        ref={invoiceRef}
        style={{
          width: "210mm",
          margin: "auto",
          padding: "20px",
          background: "#fff",
          border: "1px solid #ddd",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #000",
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
          }}
        >
          {/* Invoice Header */}
          <thead>
            <tr>
              <th
                colSpan={4}
                style={{
                  textAlign: "left",
                  padding: "20px",
                  fontSize: "24px",
                  background: "#0077B6",
                  color: "#fff",
                }}
              >
                TAX INVOICE
              </th>
              <th
                colSpan={4}
                style={{
                  textAlign: "right",
                  padding: "20px",
                  background: "#0077B6",
                  color: "#fff",
                }}
              >
                <img
                  src={logo}
                //   src="https://amasi.blazingcoders.com/static/media/logo.cc25d7fe.png"
                  alt="Logo"
                  style={{ height: "50px" }}
                  crossOrigin="anonymous"
                />
              </th>
            </tr>
          </thead>

          {/* Company Details */}
          <tbody>
            <tr>
              <td
                colSpan={3}
                style={{ padding: "15px", borderBottom: "1px solid #000" }}
              >
                <strong>
                  Association of Minimal Access Surgeons of India (AMASI)
                </strong>
                <br />
                {webaddress}
                <br />
                <b>Phone</b> : {webphone} | <b>Email</b> : {webemail} <br /> <b>GSTIN</b> : {webgst}
              </td>

              <td
                colSpan={5}
                style={{
                  padding: "15px",
                  textAlign: "right",
                  borderBottom: "1px solid rgb(0, 0, 0)",
                  fontSize: "14px",
                  color: "#1E3A8A",
                  lineHeight: "1.6",
                }}
              >
                <div>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ padding: "5px 10px", fontWeight: "bold", color: "#000", textAlign: "start" }}>Invoice No</td>
                        <td style={{ padding: "5px 10px", textAlign: "start" }}>: {invoiceNumber}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 10px", fontWeight: "bold", color: "#000", textAlign: "start" }}>Membership No</td>
                        <td style={{ padding: "5px 10px", textAlign: "start" }}>: {memberNumber}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 10px", fontWeight: "bold", color: "#000", textAlign: "start" }}>Issue Date</td>
                        <td style={{ padding: "5px 10px", textAlign: "start" }}>: {issueDate}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 10px", fontWeight: "bold", color: "#000", textAlign: "start" }}>Place of Supply</td>
                        <td style={{ padding: "5px 10px", textAlign: "start" }}>: TN (33)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>


            {/* Billing Details */}
            <tr style={{background: '#E1F5FE'}}>
              <td colSpan={8} style={{padding: '15px', borderBottom: '1px solid #000'}}>
                <strong>Bill To:</strong>
                {' '}
                {memberDetails.salutation ? memberDetails.salutation : ''}
                {memberDetails.first_name ? memberDetails.first_name : ''}
                {memberDetails.middle_name ? ' ' + memberDetails.middle_name : ''}
                {memberDetails.last_name ? ' ' + memberDetails.last_name : ''}
                <br />
                {memberDetails.street_line1}, {memberDetails.city},{' '}
                {memberDetails.state_name}, {memberDetails.pin}
              </td>
            </tr>

            {/* Invoice Items */}
            <tr style={{ background: "#0077B6", color: "#fff" }}>
              <th style={{ padding: "12px", border: "1px solid #000" }}>
                S.No
              </th>
              <th style={{ padding: "12px", border: "1px solid #000" }}>
                Description
              </th>
              <th style={{ padding: "12px", border: "1px solid #000" }}>
                HSN/SAC
              </th>
              {/* <th style={{ padding: "12px", border: "1px solid #000" }}>Qty</th> */}
              <th style={{ padding: "12px", border: "1px solid #000" }}>
                Price (INR)
              </th>
              {memberDetails &&`${memberDetails.state}` === "4035" ? (
                <>
                  <th style={{ padding: "12px", border: "1px solid #000" }}>CGST</th>
                  <th style={{ padding: "12px", border: "1px solid #000" }}>SGST</th>
                </>
              ) : (
                <th style={{ padding: "12px", border: "1px solid #000" }}>IGST</th>
              )}
              <th style={{ padding: "12px", border: "1px solid #000" }}>
                Amount
              </th>
            </tr>

            <tr style={{ background: "#CAF0F8" }}>
              <td
                style={{
                  padding: "12px",
                  border: "1px solid #000",
                  textAlign: "center",
                }}>1</td>
              <td style={{ padding: "12px", border: "1px solid #000" }}>
                {applicationDetails.application_name} Fee
              </td>
              <td
                style={{
                  padding: "12px",
                  border: "1px solid #000",
                  textAlign: "center",
                }}
              >
                9995
                {/* {webgst} */}
              </td>
              {/* <td
                style={{
                  padding: "12px",
                  border: "1px solid #000",
                  textAlign: "center",
                }}
              >
                1
              </td> */}
              <td
                style={{
                  padding: "12px",
                  border: "1px solid #000",
                  textAlign: "center",
                }}
              >
                ₹ {applicationDetails.fee}/-
              </td>
              {memberDetails && `${memberDetails.state}` === "4035" ? (
                <>
                  <td
                    style={{
                      padding: "12px",
                      border: "1px solid #000",
                      textAlign: "center",
                      whiteSpace: "nowrap"
                    }}
                  >
                    ₹ {applicationDetails.gstAmount / 2}/-
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      border: "1px solid #000",
                      textAlign: "center",
                      whiteSpace: "nowrap"
                    }}
                  >
                    ₹ {applicationDetails.gstAmount / 2}/-
                  </td>
                </>
              ) : (
                <td
                  style={{
                    padding: "12px",
                    border: "1px solid #000",
                    textAlign: "center",
                    whiteSpace: "nowrap"
                  }}
                >
                  ₹ {applicationDetails.gstAmount}/-
                </td>
              )}
              <td
                style={{
                  padding: "12px",
                  border: "1px solid #000",
                  textAlign: "center",
                  whiteSpace: "nowrap"
                }}
              >
                ₹ {applicationDetails.totalPrice}/-
              </td>
            </tr>

            {/* Summary */}
            <tr style={{ background: "#f1f1f1", fontWeight: "bold" }}>
              <td
                colSpan={memberDetails && `${memberDetails.state}` === "4035" ?6:5}
                style={{
                  textAlign: "right",
                  padding: "12px",
                  border: "1px solid #000",
                  whiteSpace: "nowrap"
                }}
              >
                Total @{applicationDetails.gst_value}%:
              </td>
              <td
                colSpan={2}
                style={{ padding: "12px", border: "1px solid #000" }}
              >
                ₹ {applicationDetails.gstAmount}/-
              </td>
            </tr>

            {/* Grand Total */}
            <tr style={{ background: "#E1F5FE", fontWeight: "bold" }}>
              <td
               colSpan={memberDetails && `${memberDetails.state}` === "4035" ?6:5}
                style={{
                  textAlign: "right",
                  padding: "15px",
                  border: "1px solid #000",
                }}
              >
                Grand Total:
              </td>
              <td
                colSpan={2}
                style={{ padding: "15px", border: "1px solid #000", whiteSpace: "nowrap" }}
              >
                ₹ {applicationDetails.totalPrice}/-
              </td>
            </tr>

            {/* Footer */}
            <tr>
              <td
                colSpan={memberDetails && `${memberDetails.state}` === "4035" ?4:3}
                style={{ padding: "15px", fontSize: "14px", color: "#0077B6" }}
              >
                <strong>Amount in Words:</strong> INR {amountInWords}
              </td>
              <td
                colSpan={4}
                style={{
                  padding: "15px",
                  textAlign: "right",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Net Received: (-) ₹ {applicationDetails.totalPrice}
              </td>
            </tr>

            <tr>
              <td
                colSpan={8}
                style={{
                  textAlign: "center",
                  padding: "15px",
                  background: "#0077B6",
                  color: "#fff",
                  fontSize: "14px",
                }}
              >
                Online payment doesn’t need e-signature.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Invoice;
